import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const VerifyOtp = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [timer, setTimer] = useState(60);
  const [error, setError] = useState("");
  const inputRefs = useRef([]);
  const navigate = useNavigate();

  const savedOtp = sessionStorage.getItem("login_otp");
  const savedMobile = sessionStorage.getItem("login_mobile");

  // ⭐ Static credentials
  const STATIC_MOBILE = "9790934910";
  const STATIC_OTP = "123456";
  // const STATIC_OTP = "960005";

  // Auto focus first box on load
  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  // Timer countdown
  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => setTimer((t) => t - 1), 1000);
      return () => clearInterval(interval);
    }
  }, [timer]);

  const handleChange = (value, index) => {
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      if (value && index < 5) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const enteredOtp = otp.join("");

    // ⭐ STATIC MOBILE CASE
    if (savedMobile === STATIC_MOBILE) {
      if (enteredOtp === STATIC_OTP) {
        navigate("/personalInformation");
        sessionStorage.removeItem("login_otp");
      } else {
        setError("Invalid OTP for admin number!");
      }
      return;
    }

    // ⭐ NORMAL USER OTP VALIDATION
    if (enteredOtp === savedOtp) {
      navigate("/personalInformation");
      sessionStorage.removeItem("login_otp");
    } else {
      setError("Invalid OTP! Please try again.");
    }
  };

  const handleResendOtp = async () => {
    if (!savedMobile) {
      setError("Mobile number not found. Please login again.");
      return;
    }

    let newOtp;

    // ⭐ IF STATIC MOBILE → FORCE STATIC OTP, DO NOT GENERATE
    if (savedMobile === STATIC_MOBILE) {
      newOtp = STATIC_OTP;
      sessionStorage.setItem("login_otp", newOtp);
    } else {
      // NORMAL FLOW → GENERATE RANDOM OTP
      newOtp = Math.floor(100000 + Math.random() * 900000);
      sessionStorage.setItem("login_otp", newOtp);
    }

    try {
      await axios.post(
        "https://capi.2kvirtualworld.com/usppackinglive/api/sms/send-otp",
        {},
        {
          params: {
            phoneNumber: savedMobile,
            otp: newOtp,
          },
        }
      );

      setTimer(60);
      setOtp(["", "", "", "", "", ""]);
      inputRefs.current[0].focus();
      setError("");
      alert("OTP resent successfully!");
    } catch (err) {
      console.error(err);
      setError("Failed to resend OTP. Try again.");
    }
  };

  return (
    <div className="verify-wrapper">
      <div className="verify-card">
        <button className="close-btn" onClick={() => navigate("/")}>
          &times;
        </button>

        <h3 className="verify-title">Verify your Mobile Number</h3>

        <p className="verify-subtitle">
          Enter OTP sent to <strong>{savedMobile}</strong>
        </p>

        <form onSubmit={handleSubmit}>
          <div className="otp-inputs">
            {otp.map((digit, i) => (
              <input
                key={i}
                type="text"
                maxLength={1}
                value={digit}
                ref={(el) => (inputRefs.current[i] = el)}
                onChange={(e) => handleChange(e.target.value, i)}
                onKeyDown={(e) => handleKeyDown(e, i)}
                className="otp-box"
              />
            ))}
          </div>

          {error && <p className="error-text">{error}</p>}

          <div className="timer-circle">
            <span>{timer}s</span>
          </div>

          <p className="resend-text">
            Didn’t receive OTP?{" "}
            <button
              type="button"
              className="resend-link"
              onClick={handleResendOtp}
              disabled={timer > 0}
            >
              Resend OTP
            </button>
          </p>

          <button type="submit" className="submit-btn">
            SUBMIT
          </button>
        </form>
      </div>
    </div>
  );
};

export default VerifyOtp;
